module.exports = __webpack_public_path__ + "static/media/yaari_bg.163baaab.png";